import { styled } from '@mui/material/styles';
import { EFontFamily } from 'helpers/constants';

export const Container = styled('div')(() => ({
  '& .MuiAlert-root': {
    height: '55px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '0 30px',
    margin: '10px 0',
    fontWeight: 500,
    fontSize: 14,
    borderRadius: '8px',
    borderWidth: ' 1px 1px 1px 10px',
    borderStyle: 'solid',
    fontFamily: EFontFamily.inter
  },

  '& .MuiAlert-action': {
    padding: 0
  },

  '& .payment-status-pending': {
    backgroundColor: '#ffdfa6',
    color: '#be8013',

    borderTopColor: '#E5B45B',
    borderRightColor: '#E5B45B',
    borderBottomColor: '#E5B45B',
    borderLeftColor: '#D98A00'
  },

  '& .payment-status-unpaid': {
    backgroundColor: '#FFDADA',
    color: '#c73b47',
    borderTopColor: '#F8B4B4',
    borderRightColor: '#F8B4B4',
    borderBottomColor: '#F8B4B4',
    borderLeftColor: '#DC3545'
  },

  '& .payment-status-paid': {
    backgroundColor: '#dde2e0',
    color: '#2F6B4F',
    borderTopColor: '#AEBDB7',
    borderRightColor: '#AEBDB7',
    borderBottomColor: '#AEBDB7',
    borderLeftColor: '#2F8F62'
  }
}));
